module.exports = __webpack_public_path__ + "img/l2.e6c1bda4.png";